export default __webpack_public_path__ + "static/media/empty_folder.3725ffc8.png";